import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecurrenceEditorComponent } from './recurrenceeditor.component';
/**
 * NgModule definition for the RecurrenceEditor component.
 */
export class RecurrenceEditorModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        RecurrenceEditorComponent
    ],
    exports: [
        RecurrenceEditorComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function RecurrenceEditorModule_tsickle_Closure_declarations() {
/** @type {?} */
RecurrenceEditorModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RecurrenceEditorModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
